import React from "react";
import "./Contact.css";

function Contact() {
  return (
    <section className="contact" id="contact">
      <div className="contact__container">
      <h1 className="contact__title">CONTACT</h1>
        <p className="contact__description">
          For general enquiries, please use the form below and one of our
          dedicated team members will be in touch with you shortly
        </p>
        <p className="contact__text">
          <a className="contact__link" href="tel:+17712014010">
            +1 (771) 201-4010
          </a>
        </p>
        <p className="contact__text">
          <a className="contact__link" href="mailto:mikdashdevelopment@gmail.com">
            mikdashdevelopment@gmail.com
          </a>
        </p>
        <p className="contact__text">11234, NY</p>
      </div>
    </section>
  );
}

export default Contact;
